import { render, staticRenderFns } from "./DevicePurchaseList.vue?vue&type=template&id=4a84aca8&scoped=true"
import script from "./DevicePurchaseList.vue?vue&type=script&lang=js"
export * from "./DevicePurchaseList.vue?vue&type=script&lang=js"
import style0 from "./DevicePurchaseList.vue?vue&type=style&index=0&id=4a84aca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84aca8",
  null
  
)

export default component.exports